/** Prepinac temat galerie: data-theme na <html> + localStorage. */

export const THEME_NAMES = ['reos', 'kokpit', 'fakturace-a', 'fakturace-b'] as const;
export type ThemeName = (typeof THEME_NAMES)[number];

const STORAGE_KEY = 'redhand-gallery-theme';

export function isThemeName(value: string | null): value is ThemeName {
  return value !== null && (THEME_NAMES as readonly string[]).includes(value);
}

export function getStoredTheme(): ThemeName {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return isThemeName(raw) ? raw : 'reos';
  } catch {
    return 'reos';
  }
}

export function applyTheme(theme: ThemeName): void {
  document.documentElement.dataset['theme'] = theme;
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // localStorage nedostupna (private mode) — tema plati jen pro session
  }
}
